<template>
  <div>
    <div class="container center">
      <div class="hero-text">
        <h2>{{ content.personalData.experienceHeading }}</h2>
        <p>{{ content.personalData.experience }}</p>
      </div>
      <div class="grid companies">
        <img v-for="(company, index) in content.companies" :key="company.id" :src="company"
          :title="`Company-${index + 1}`" />
      </div>
    </div>
    <ul class="portfolio">
      <li v-for="item in content.portfolio" :key="item.id" class="portfolio-item">
        <router-link :to="`${item.link}`" :style="{ 'background-image': `url(${item.poster})` }"
          class="navigation-link">
          <div class="portfolio-item-text">
            <span>{{ item.thumbName }}</span>
            <p>
              {{ item.thumbText }}
            </p>
          </div>
        </router-link>
      </li>
    </ul>
      <div class="container recommendations">
        <div class="recommendation_image">
          <img src="img/mica.png" alt="Mica">
        </div>
        <div class="recommendation">
          <h3>Mica Olsson</h3>
          <h4>22 October 2021, Lead Lighting Artist at Goodbye Kansas</h4>
          <p>Worked with Daniel on a AAA game project where we needed assistance with environment and asset creation and
            general game development experience.
            Everything went on great working on the project, communications were very straight forward and easy and he
            was always creative on solutions.</p>
        </div>
        <div class="recommendation_image">
          <img src="img/anders.png" alt="Anders">
        </div>
        <div class="recommendation">
          <h3>Anders Elfgren</h3>
          <h4>01 November 2023, Programmer and Co-Founder @ Warpzone Studios</h4>
          <p>Daniel is an exceptional artist and a lovely team worker. He's fast and makes art that oozes with heart.
            The art he made for Hammerting was one of the main draws of the game and we couldn't have made the game
            without him. He is keen to help and teach. When he has an idea, he won't just tell you about it, he'll whip
            up a demo to show you.</p>
        </div>
        <div class="recommendation_image">
          <img src="img/martin.png" alt="Martin">
        </div>
        <div class="recommendation">
          <h3>Martin Annander</h3>
          <h4>18 October 2021, CEO and Co-Founder @ Tik Tek Toe</h4>
          <p>Hired Daniel to make a promotional video for a card game project. Daniel delivered above and beyond what
            was expected. The conversation was always constructive and the results have been amazing. I can
            wholeheartedly recommend Daniel, and hope to work with him again!</p>
        </div>
      </div>
  </div>
</template>

<script>
import content from "../../public/content.json";

export default {
  name: "Portfolio",
  components: {},
  data() {
    return {
      content,
    };
  },
};
</script>

<style lang="scss" scoped>
$small: "screen and (max-width: 1024px)";
$tablet: "screen and (max-width: 700px)";
$mobile: "screen and (max-width: 500px)";
$tiny: "screen and (max-width: 350px)";

.portfolio {
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media #{$tablet} {
    grid-template-columns: 1fr;
  }

  .portfolio-item {
    position: relative;
    padding-bottom: 50%;
    overflow: hidden;

    &:last-child {
      display: none;
    }

    .navigation-link {
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      color: white;
      text-decoration: none;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0);
        transition: var(--transition);
      }

      .portfolio-item-text {
        padding: var(--spacing-default);
        font-size: 1.8rem;
        opacity: 0;
        z-index: 1;

        span {
          font-size: 2.4rem;
          margin: 0;
          line-height: 1;
        }

        p {
          font-size: 1.0rem;
          margin: 0rem 0;
        }

        transition: var(--transition);

        @media #{$small} {
          display: none;
        }
      }

      &:hover {
        &::after {
          background-color: rgba(0, 0, 0, 0.534);

          @media #{$small} {
            background-color: transparent;
          }
        }

        .portfolio-item-text {
          opacity: 1;
        }
      }
    }
  }
}

.grid {
  display: grid;
  gap: 0.3rem;
  margin-bottom: var(--spacing-large);

  &.companies {
    grid-auto-flow: column;
    @media #{$tiny} {
      grid-auto-flow: initial;
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    >img {
      width: 100%;
      padding: 0%;
      margin: 0%;
      background-color: #ffffff;
      align-items: center;
      position: relative;
    }
  }
}

.recommendations {
  display: flex;
  text-align: left;
  @media #{$small} {
    display: block;
  }

  .recommendation {
    flex: 1;
    flex: 2;
    padding-left: 1rem;
    @media #{$small} {
      padding-left: 0;
    }
  }

  .recommendation_image {
    height: 76px;
    width: 76px;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
